import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin: 10px 0;
`

const KeyWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`

const KeyIcon = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid ${({ theme }) => theme?.['-ds-neutral-300']?.value};

  &.check-in {
    background: linear-gradient(
      to top left,
      #fff 0%,
      #fff 49.9%,
      #ececec 50%,
      #ececec 100%
    );
  }

  &.check-out {
    background: linear-gradient(
      to bottom right,
      #fff 0%,
      #fff 49.9%,
      #ececec 50%,
      #ececec 100%
    );
  }
`

const CalendarKeys = () => {
  return (
    <Wrapper>
      <KeyWrapper>
        <KeyIcon className="check-in" />
        Check-in only
      </KeyWrapper>

      <KeyWrapper>
        <KeyIcon className="check-out" />
        Checkout only
      </KeyWrapper>
    </Wrapper>
  )
}

export default CalendarKeys
